import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { EditProfileFilter } from '@components/Profile/EditProfile/EditProfileFilter';
import { EditProfileForm } from '@components/Profile/EditProfile/EditProfileForm';
import { Page404, Page500 } from '@containers/ErrorPages';
import { profileApi } from '@reducers/profile/profile';

const EditExistingProfile = ({ profileID }) => {
  const { data, isLoading, isError, error } = profileApi.useGetDetailsQuery({
    id: profileID,
  });
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError && error.status === 404) {
    return <Page404 />;
  }
  if (isError) {
    return <Page500 />;
  }

  return (
    <Row>
      <Col md={3}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            Check profile requirements
          </Card.Header>
          <Card.Body>
            <EditProfileFilter />
          </Card.Body>
        </Card>
      </Col>
      <Col md={9}>
        <EditProfileForm profileID={profileID} data={data} />
      </Col>
    </Row>
  );
};

export const EditProfile = () => {
  const { profileID } = useParams();
  if (!profileID) {
    return <Page404 />;
  }

  return <EditExistingProfile profileID={profileID} />;
};
